<template>
    <v-tooltip bottom :color="color" :disabled="!$vuetify.breakpoint[this.breakpoint]">
        <template v-slot:activator="{ on, attrs }">
          <span v-bind="attrs" v-on="on">
              <slot></slot>
          </span>
        </template>
        <span>{{text}}</span>
    </v-tooltip>
</template>

<script>
    export default {
        name: "tool-tip",
        props: {
            text: {default: ''},
            color: {default: ''},
            breakpoint: {default: 'mdAndUp'},
        },
    }
</script>

<style scoped>

</style>